import { useEffect } from 'react';

const useInlineScript = (ref: React.RefObject<HTMLElement | null>, html: string) => {
  useEffect(() => {
    const node = document.createRange().createContextualFragment(html);
    ref.current?.appendChild(node);

    return () => {
      if (ref.current) {
        ref.current.textContent = '';
      }
    };
  }, [ref, html]);
};

export default useInlineScript;
